export default __webpack_public_path__ + "static/media/logo.7f5e8ac7.png?v=elephant-20261103";